import { render, staticRenderFns } from "./ThemesEditorContentTypeFieldsBtn.vue?vue&type=template&id=f3ff247a&scoped=true"
import script from "./ThemesEditorContentTypeFieldsBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorContentTypeFieldsBtn.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ThemesEditorContentTypeFieldsBtn.vue?vue&type=style&index=0&id=f3ff247a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ff247a",
  null
  
)

export default component.exports